/* [MENU_DRAWER_OUTSIDE_CLICK_CLOSE__ANIM_SAFE] */
document.addEventListener("DOMContentLoaded", () => {
  const detailsEl = document.getElementById("Details-menu-drawer-container");
  const drawerEl = document.getElementById("menu-drawer");

  // If your theme doesn't have this drawer on the current page, do nothing.
  if (!detailsEl || !drawerEl) return;

  // The toggle button is usually the <summary> inside the <details>.
  const summaryEl = detailsEl.querySelector("summary");

  /**
   * Close the drawer in the most theme-compatible way possible:
   * 1) Call a built-in close method if available (keeps animations + focus handling).
   * 2) Otherwise click the <summary> (triggers the theme’s open/close logic).
   * 3) Fallback: force-close the <details> (no animation, last resort).
   */
  const closeDrawerWithThemeBehavior = () => {
    if (!detailsEl.open) return;

    const headerDrawerEl = detailsEl.closest("header-drawer");

    // 1) Try calling a theme-provided close method (names vary by theme).
    if (headerDrawerEl) {
      if (typeof headerDrawerEl.close === "function") {
        headerDrawerEl.close();
        return;
      }
      if (typeof headerDrawerEl.closeMenuDrawer === "function") {
        headerDrawerEl.closeMenuDrawer();
        return;
      }
      if (typeof headerDrawerEl.onClose === "function") {
        headerDrawerEl.onClose();
        return;
      }
    }

    // 2) Trigger a normal UI close (most themes attach animations to this path)
    if (summaryEl) {
      summaryEl.click();
      return;
    }

    // 3) Last resort (can “blink” because it skips theme animation classes)
    detailsEl.open = false;
  };

  /**
   * Close when clicking outside the drawer.
   * Use capture=true so we reliably see the click even if the theme stops propagation later.
   */
  document.addEventListener(
    "pointerdown",
    (e) => {
      if (!detailsEl.open) return;

      // If click is inside the drawer component (including the toggle button), don't close.
      if (detailsEl.contains(e.target)) return;

      closeDrawerWithThemeBehavior();
    },
    { capture: true }
  );

  /* [MENU_DRAWER_ESC_CLOSE] */
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeDrawerWithThemeBehavior();
  });

  /* [MENU_DRAWER_CLOSE_ON_LINK_CLICK] */
  drawerEl.addEventListener("click", (e) => {
    const link = e.target.closest("a");
    if (link) closeDrawerWithThemeBehavior();
  });
});
